'use strict';

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.bindActions = undefined;

var _toConsumableArray2 = require('babel-runtime/helpers/toConsumableArray');

var _toConsumableArray3 = _interopRequireDefault(_toConsumableArray2);

var _regenerator = require('babel-runtime/regenerator');

var _regenerator2 = _interopRequireDefault(_regenerator);

var _asyncToGenerator2 = require('babel-runtime/helpers/asyncToGenerator');

var _asyncToGenerator3 = _interopRequireDefault(_asyncToGenerator2);

require('whatwg-fetch');

require('es6-promise/auto');

var _Dom = require('common/Dom');

var _Dom2 = _interopRequireDefault(_Dom);

var _Constants = require('common/Constants');

var _Constants2 = _interopRequireDefault(_Constants);

var _Helpers = require('common/Helpers');

var _Flow = require('components/Flow');

var _Flow2 = _interopRequireDefault(_Flow);

var _product = require('state/product');

var _state = require('state');

var _state2 = _interopRequireDefault(_state);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

var removeUncheckedGiftBoxAtCheckout = function () {
  var _ref = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee() {
    var requests;
    return _regenerator2.default.wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            requests = $(_Dom2.default.getFreeGiftBoxCheckbox).get().filter(function (checkbox) {
              return !checkbox.checked;
            }).map(function (checkbox) {
              return (0, _Helpers.getContainer)({ self: checkbox, type: 'line-item' });
            }).map(function (container) {
              return _state2.default.get(container).key;
            }).map(function (key) {
              return { method: 'removeItem', args: [key], adjustGiftBoxCount: false };
            });


            PubSub.publish(_Constants2.default.batchRequests, requests);

            return _context.abrupt('return', new Promise(function (resolve) {
              return setTimeout(function () {
                return resolve();
              }, 500);
            }));

          case 3:
          case 'end':
            return _context.stop();
        }
      }
    }, _callee, undefined);
  }));

  return function removeUncheckedGiftBoxAtCheckout() {
    return _ref.apply(this, arguments);
  };
}();

var findUpsells = function findUpsells(container) {
  return $(_Dom2.default.pdpUpsellCheckbox, container).filter(':checked').parent().get().map(function (element) {
    var variantId = parseInt($(_Dom2.default.pdpUpsellCheckbox, element).val());
    var properties = { _center: '1003' };

    return { method: 'addItem', args: [variantId, { properties: properties }] };
  });
};

var handlePortalClick = function handlePortalClick(_ref2) {
  var self = _ref2.currentTarget;

  var target = $(self).data('portal');
  var action = $(self).data('trigger');

  $(target).trigger(action);

  return false;
};

var handleAddToCartClick = function () {
  var _ref3 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee2(event) {
    var self, container, variantId, upsells, properties, requests;
    return _regenerator2.default.wrap(function _callee2$(_context2) {
      while (1) {
        switch (_context2.prev = _context2.next) {
          case 0:
            // await Flow.isReady();

            self = event.currentTarget;
            container = (0, _Helpers.getContainer)({ self: self, type: 'product' });
            variantId = (0, _product.getVariant)(container);
            upsells = findUpsells(container);
            properties = {};

            // console.log('variantId', variantId);

            requests = [{ method: 'addItem', args: [variantId, { properties: properties }] }].concat((0, _toConsumableArray3.default)(upsells));

            // console.log('===', requests);

            PubSub.publish(_Constants2.default.batchRequests, requests);

            return _context2.abrupt('return', false);

          case 8:
          case 'end':
            return _context2.stop();
        }
      }
    }, _callee2, undefined);
  }));

  return function handleAddToCartClick(_x) {
    return _ref3.apply(this, arguments);
  };
}();

var handleRemoveFromCartClick = function handleRemoveFromCartClick(event) {
  event.preventDefault();

  var self = event.currentTarget;

  var container = (0, _Helpers.getContainer)({ self: self, type: 'line-item' });

  var _State$get = _state2.default.get(container),
      key = _State$get.key;

  PubSub.publish(_Constants2.default.removeFromCart, { key: key, openInlineCart: false });

  return false;
};

var handleCheckoutLinkClick = function () {
  var _ref4 = (0, _asyncToGenerator3.default)( /*#__PURE__*/_regenerator2.default.mark(function _callee3(event) {
    var self, upsells, flowActive;
    return _regenerator2.default.wrap(function _callee3$(_context3) {
      while (1) {
        switch (_context3.prev = _context3.next) {
          case 0:
            event.preventDefault();

            _state2.default.set({ change: 'checkout', container: 'checkout', active: true });

            self = event.currentTarget;
            upsells = _state2.default.get('upsell');
            _context3.next = 6;
            return _Flow2.default.isActive();

          case 6:
            flowActive = _context3.sent;

            if (!upsells.giftBox) {
              _context3.next = 10;
              break;
            }

            _context3.next = 10;
            return removeUncheckedGiftBoxAtCheckout(self);

          case 10:

            if (flowActive) {
              window.Flow.checkout.redirect();
            } else {
              window.location.href = '/checkout';
            }

            return _context3.abrupt('return', false);

          case 12:
          case 'end':
            return _context3.stop();
        }
      }
    }, _callee3, undefined);
  }));

  return function handleCheckoutLinkClick(_x2) {
    return _ref4.apply(this, arguments);
  };
}();

var handleOptionValueClick = function handleOptionValueClick(event) {
  event.preventDefault();

  var self = event.currentTarget;
  var _self$dataset = self.dataset,
      optionName = _self$dataset.optionName,
      optionValue = _self$dataset.optionValue;

  var container = (0, _Helpers.getContainer)({ self: self, type: 'product' });
  var id = container.dataset.containerId;


  var name = (0, _Helpers.handlize)(optionName);
  var value = (0, _Helpers.handlize)(optionValue);

  PubSub.publish(_Constants2.default.optionValueChange, { id: id, name: name, value: value });
  return false;
};

var updateCartCount = function updateCartCount(data) {
  var cartState = _state2.default.get('cart');

  $(_Dom2.default.cartItemCount).text(cartState.item_count);
};

var bindActions = exports.bindActions = function bindActions() {
  // eslint-disable-next-line func-names
  $(document).on('click', _Dom2.default.addToCart, function (event) {
    // console.log('==== ATC CLICK FROM CART CONTROLE');

    handleAddToCartClick(event);
  });
  $(document).on('click', _Dom2.default.removeFromCart, handleRemoveFromCartClick);
  // these break the event argument passed to handler
  // $(document).on('click', dom.addToCart, debounce(handleAddToCartClick, 350));
  // $(document).on('click', dom.removeFromCart, debounce(handleRemoveFromCartClick, 350));
  $(document).on('click', _Dom2.default.pdpOptionValue, handleOptionValueClick);
  $(document).on('click', _Dom2.default.portal, handlePortalClick);
  $(document).on('click', _Dom2.default.guestCheckoutLink, handleCheckoutLinkClick);
  $(document).on('submit', _Dom2.default.inlineCartCheckoutFormSignIn, handleCheckoutLinkClick);
  $(document).on('submit', _Dom2.default.inlineCartCheckoutFormCreate, handleCheckoutLinkClick);

  updateCartCount();
};